// import React, { useState, useEffect, useRef } from 'react';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
// import { Pie } from 'react-chartjs-2';
// import * as XLSX from 'xlsx';
// import styles from './PercentageAnalysis.module.css';
// import { targetAnalyticsApi } from '../../../../api/targetAnalytics/targetAnalyticsApi';
// import InvoiceFilterModal from './modal/TargetInvoiceDetailsModal';

// ChartJS.register(ArcElement, Tooltip, Legend);

// const PercentageAnalysis = () => {
//   const [selectedType, setSelectedType] = useState('region');
//   const [selectedYear, setSelectedYear] = useState('FY 2025-26');
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const chartRef = useRef(null);
//   const [showInvoiceModal, setShowInvoiceModal] = useState(false);
//   const [selectedField, setSelectedField] = useState(null);

//   const typeOptions = [
//     { value: 'category', label: 'Category' },
//     { value: 'state', label: 'State' },
//     { value: 'region', label: 'Region' },
//     { value: 'salesperson', label: 'Sales Person' },
//   ];

//   const yearOptions = ['FY 2025-26', 'FY 2024-25', 'Complete'];

//   // Target values for FY 2025-26
//   const regionTargets = {
//     Central: 10.9,
//     'West 1': 5.4,
//     North: 5.4,
//     South: 7.2,
//     'West 2': 5.4,
//     East: 1.8,
//   };

//   useEffect(() => {
//     fetchData();
//   }, [selectedType, selectedYear]);

//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const result = await targetAnalyticsApi.getPercentageAnalysis(selectedType, selectedYear);
//       setData(result.data || []);
//     } catch (err) {
//       setError('Failed to load data');
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCheckSales = (field) => {
//     setSelectedField(field);
//     setShowInvoiceModal(true);
//   };

//   const toCrores = (value) => {
//     return (value / 10000000).toFixed(2);
//   };

//   // Weighted average margin since backend only returns GrossMarginPct (no GrossProfit field)
//   const calculateTotalMargin = (data) => {
//     if (!data || data.length === 0) return 0;
//     const totalSales = data.reduce((sum, row) => sum + (row.Sales || 0), 0);
//     const weighted = data.reduce((sum, row) => sum + ((row.Sales || 0) * (row.GrossMarginPct || 0)), 0);
//     return totalSales > 0 ? Number((weighted / totalSales).toFixed(2)) : 0;
//   };

//   const ProgressBar = ({ current, target, label, compact = false }) => {
//     const currentCr = typeof current === 'number' ? current / 10000000 : 0;
//     const targetCr = typeof target === 'number' ? target : 0;
//     const percentage = targetCr > 0 ? Math.min((currentCr / targetCr) * 100, 100) : 0;

//     const getColor = (pct) => {
//       if (pct >= 80) return '#15803d';
//       if (pct >= 60) return '#22c55e';
//       if (pct >= 40) return '#f59e0b';
//       return '#dc2626';
//     };

//     return (
//       <div className={styles.progressBarContainer}>
//         <div className={styles.progressBarHeader}>
//           {label && <span>{label}</span>}
//           <span style={{ color: getColor(percentage) }}>
//             {percentage.toFixed(1)}%
//           </span>
//         </div>
//         <div className={styles.progressBarTrack}>
//           <div
//             className={styles.progressBarFill}
//             style={{
//               width: `${percentage}%`,
//               backgroundColor: getColor(percentage)
//             }}
//           />
//           <div className={styles.progressBarText}>
//             ₹{currentCr.toFixed(2)} / ₹{targetCr.toFixed(2)} Cr
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const exportToExcel = () => {
//     if (data.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const totalMargin = calculateTotalMargin(data);
//     const isCategory = selectedType === 'category';
//     const showTarget = selectedYear === 'FY 2025-26' && (isCategory || selectedType === 'region');

//     const exportData = data.map(row => {
//       const base = {
//         Field: row.Field,
//         'Sales (Cr)': toCrores(row.Sales),
//         '% Sales': row.PercentageSales,
//         'GM %': row.GrossMarginPct,
//       };

//       if (showTarget) {
//         base['Target (Cr)'] = (row.Target || 0).toFixed(2);
//         const currentCr = parseFloat(toCrores(row.Sales));
//         const targetCr = row.Target || 0;
//         base['Achievement %'] = targetCr > 0 ? ((currentCr / targetCr) * 100).toFixed(1) : '0.0';
//       }
//       return base;
//     });

//     const totals = {
//       Field: 'TOTAL',
//       'Sales (Cr)': toCrores(data.reduce((sum, r) => sum + (r.Sales || 0), 0)),
//       '% Sales': 100.0,
//       'GM %': totalMargin,
//     };

//     if (showTarget) {
//       const totalTargets = data.reduce((sum, r) => sum + (r.Target || 0), 0);
//       totals['Target (Cr)'] = totalTargets.toFixed(2);
//       const totalSalesCr = parseFloat(toCrores(data.reduce((sum, r) => sum + (r.Sales || 0), 0)));
//       totals['Achievement %'] = totalTargets > 0 ? ((totalSalesCr / totalTargets) * 100).toFixed(1) : '0.0';
//     }

//     exportData.push(totals);

//     const ws = XLSX.utils.json_to_sheet(exportData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Percentage Analysis');
//     XLSX.writeFile(
//       wb,
//       `Percentage_Analysis_${selectedType}_${selectedYear}_${new Date().toISOString().split('T')[0]}.xlsx`
//     );
//   };

//   const chartData = {
//     labels: data.map(d => d.Field),
//     datasets: [
//       {
//         data: data.map(d => d.PercentageSales),
//         backgroundColor: [
//           '#15803d', '#16a34a', '#22c55e', '#4ade80', '#86efac',
//           '#bbf7d0', '#dcfce7', '#059669', '#10b981', '#34d399',
//         ],
//         borderColor: '#ffffff',
//         borderWidth: 2,
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: true,
//     plugins: {
//       legend: {
//         position: 'bottom',
//         labels: {
//           padding: 10,
//           font: { size: 10 },
//           boxWidth: 15,
//         },
//       },
//       tooltip: {
//         callbacks: {
//           label: (ctx) => `${ctx.label}: ${ctx.parsed}%`,
//         },
//       },
//     },
//   };

//   if (loading) {
//     return (
//       <div className={styles.loadingContainer}>
//         <div className={styles.loadingSpinner} />
//         <div className={styles.loadingText}>Loading data...</div>
//       </div>
//     );
//   }

//   const totalMargin = calculateTotalMargin(data);
//   const isCategory = selectedType === 'category';
//   const showTarget = selectedYear === 'FY 2025-26' && (selectedType === 'category' || selectedType === 'region');
//   const totalTargets = showTarget ? data.reduce((sum, r) => sum + (r.Target || 0), 0) : 0;

//   return (
//     <div className={styles.wrapper}>
//       <div className={styles.filtersSection}>
//         <div className={styles.filterRow}>
//           <div className={styles.filterGroup}>
//             <label className={styles.filterLabel}>Financial Year:</label>
//             <select
//               value={selectedYear}
//               onChange={(e) => setSelectedYear(e.target.value)}
//               className={styles.select}
//             >
//               {yearOptions.map(year => (
//                 <option key={year} value={year}>{year}</option>
//               ))}
//             </select>
//           </div>

//           <div className={styles.filterGroup}>
//             <label className={styles.filterLabel}>Analysis By:</label>
//             <select
//               value={selectedType}
//               onChange={(e) => setSelectedType(e.target.value)}
//               className={styles.select}
//             >
//               {typeOptions.map(option => (
//                 <option key={option.value} value={option.value}>{option.label}</option>
//               ))}
//             </select>
//           </div>

//           <div className={styles.excelButtonWrapper}>
//             <button
//               onClick={exportToExcel}
//               disabled={data.length === 0}
//               className={styles.excelButton}
//             >
//               <span className={styles.excelIcon}>📊</span>
//               Export Excel
//             </button>
//           </div>
//         </div>
//       </div>

//       {error && <div className={styles.errorMessage}>{error}</div>}

//       {data.length === 0 ? (
//         <div className={styles.emptyState}>
//           <div className={styles.emptyIcon}>📊</div>
//           <h3 className={styles.emptyTitle}>No Data Available</h3>
//           <p className={styles.emptyText}>No data found for the selected filters</p>
//         </div>
//       ) : (
//         <div className={styles.content}>
          

//           <div className={styles.tableSection}>
//             <div className={styles.tableWrapper}>
//               <table className={styles.table}>
//                 <thead>
//                   <tr>
//                     <th className={styles.thSticky}>{typeOptions.find(o => o.value === selectedType)?.label}</th>
//                     <th className={styles.th}>Actions</th>
//                     <th className={styles.th}>Sales (Cr)</th>
//                     <th className={styles.th}>% Sales</th>
//                     {showTarget && <th className={styles.th}>Target Achievement</th>}
//                     <th className={styles.th}>GM %</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {data.map((row, idx) => (
//                     <tr key={idx} className={styles.tr}>
//                       <td className={styles.tdSticky}>{row.Field}</td>
//                       <td className={styles.td}>
//                         <button
//                           onClick={() => handleCheckSales(row.Field)}
//                           className={styles.actionButton}
//                         >
//                           📊 Check Sales
//                         </button>
//                       </td>
//                       <td className={styles.tdRight}>₹{toCrores(row.Sales)} Cr</td>
//                       <td className={styles.tdRightGreen}>{row.PercentageSales}%</td>
//                       {showTarget && (
//                         <td className={styles.tdRight}>
//                           <ProgressBar
//                             current={row.Sales}
//                             target={row.Target}
//                             compact={true}
//                           />
//                         </td>
//                       )}
//                       <td className={`${styles.tdRight} ${row.GrossMarginPct >= 25 ? styles.gmGreen : styles.gmRed}`}>
//                         {row.GrossMarginPct}%
//                       </td>
//                     </tr>
//                   ))}

//                   <tr className={styles.totalRow}>
//                     <td className={styles.tdStickyTotal}>TOTAL</td>
//                     <td className={styles.td}></td>
//                     <td className={styles.tdRightGreen}>
//                       ₹{toCrores(data.reduce((sum, r) => sum + (r.Sales || 0), 0))} Cr
//                     </td>
//                     <td className={styles.tdRightGreen}>100.00%</td>
//                     {showTarget && (
//                       <td className={styles.tdRight}>
//                         <ProgressBar
//                           current={data.reduce((sum, r) => sum + (r.Sales || 0), 0)}
//                           target={totalTargets}
//                           compact={true}
//                         />
//                       </td>
//                     )}
//                     <td className={`${styles.tdRight} ${totalMargin >= 25 ? styles.gmGreen : styles.gmRed}`}>
//                       {totalMargin}%
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {showInvoiceModal && (
//         <InvoiceFilterModal
//           show={showInvoiceModal}
//           onClose={() => {
//             setShowInvoiceModal(false);
//             setSelectedField(null);
//           }}
//           preSelectedField={selectedField}
//           selectedFilterType={selectedType}
//           selectedYear={selectedYear}
//         />
//       )}
//     </div>
//   );
// };

// export default PercentageAnalysis;

import React, { useState, useEffect, useRef } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import * as XLSX from 'xlsx';
import styles from './PercentageAnalysis.module.css';
import { targetAnalyticsApi } from '../../../../api/targetAnalytics/targetAnalyticsApi';
import InvoiceFilterModal from './modal/TargetInvoiceDetailsModal';

ChartJS.register(ArcElement, Tooltip, Legend);

// ─── Category targets for FY 2025-26 (in Crores) ────────────────────────────
const categoryTargetsSplit = {
  Trading:        { total: 20,   india: 0,    overseas: 20 },
  Density:        { total: 6.8,  india: 3.8,  overseas: 3.0 },
  '3A Chemicals': { total: 8.7,  india: 8.7,  overseas: 0 },
  Deutero:        { total: 17,   india: 6,    overseas: 11 },
  BIKAI:          { total: 5.3,  india: 5.3,  overseas: 0 },
  'Life Science': { total: 0,    india: 0,    overseas: 0 },
  CATO:           { total: 4.15, india: 4.15, overseas: 0 },
  Capricorn:      { total: 0.86, india: 0.86, overseas: 0 },
  'FD Cell':      { total: 3.46, india: 3.46, overseas: 0 },
  KANTO:          { total: 1.4,  india: 1.4,  overseas: 0 },
};

// ─── Category mapping ────────────────────────────────────────────────────────
const categoryMapping = {
  Items: 'Trading', '3A Chemicals': '3A Chemicals', Catalyst: 'Density',
  Solvent: 'Density', Polymer: 'Density', 'Fine Chemicals': 'Density',
  Reagent: 'Density', 'Biological Buffers': 'Life Science', Intermediates: 'Density',
  API: 'CATO', 'Stable Isotope reagents': 'Deutero', 'Building Blocks': 'Density',
  Membranes: 'Life Science', 'Laboratory Containers & Storage': 'FD Cell',
  Enzyme: 'Life Science', Biochemicals: 'Life Science', 'Reference Materials': 'KANTO',
  'Secondary Standards': 'KANTO', Instruments: 'BIKAI', Services: 'NULL',
  'Analytical Standards': 'KANTO', 'Nucleosides and Nucleotides': 'Life Science',
  Nitrosamine: 'CATO', 'Pesticide Standards': 'CATO', Trading: 'Trading',
  Carbohydrates: 'Life Science', 'USP Standards': 'CATO', 'EP Standards': 'CATO',
  'Indian pharmacopoeia': 'CATO', 'British Pharmacopoeia': 'CATO', Impurity: 'CATO',
  'NMR Solvents': 'Deutero', 'Stable isotopes': 'Deutero', Glucuronides: 'CATO',
  Metabolites: 'CATO', Capricorn: 'Capricorn', 'Analytical Instruments': 'BIKAI',
  'Lab Consumables': 'FD Cell', 'Equipment and Instruments': 'BIKAI', Ultrapur: 'KANTO',
  Dyes: 'Density', 'New Life Biologics': 'Life Science', 'Food Grade': 'Life Science',
  'Lab Systems & Fixtures': 'BIKAI', Peptides: 'Life Science', 'Ultrapur-100': 'KANTO',
  'Amino Acids': 'Life Science', 'Cell Culture': 'Life Science',
  'Natural Products': 'Life Science', 'Multiple Pharmacopoeia': 'CATO',
  'Metal Standard Solutions': 'KANTO', 'High Purity Acids': 'KANTO',
  'HPLC consumables': 'BIKAI', 'HPLC configurations': 'BIKAI', VOLAB: 'VOLAB',
  'Life science': 'Life Science', Kanto: 'KANTO', 'Meatls&materials': 'Density',
};

// Region targets for FY 2025-26 (in Crores)
const regionTargets = {
  Central: 10.9, 'West 1': 5.4, North: 5.4,
  South: 7.2, 'West 2': 5.4, East: 1.8,
};

// ─── Merge raw category rows into brand groups ───────────────────────────────
const mergePercentageCategories = (rawData) => {
  const mergedData = {};

  rawData.forEach((row) => {
    const targetCategory = categoryMapping[row.Field] || 'Other';
    if (targetCategory === 'NULL') return;

    if (!mergedData[targetCategory]) {
      mergedData[targetCategory] = {
        Field: targetCategory, IndiaSales: 0,
        OverseasSales: 0, TotalSales: 0, GrossProfit: 0,
      };
    }

    mergedData[targetCategory].IndiaSales    += row.IndiaSales    || 0;
    mergedData[targetCategory].OverseasSales += row.OverseasSales || 0;
    mergedData[targetCategory].TotalSales    += row.Sales         || 0;

    const gp = row.GrossProfit || 0;
    if (gp > 0) {
      mergedData[targetCategory].GrossProfit += gp;
    } else {
      mergedData[targetCategory].GrossProfit +=
        (row.Sales || 0) * ((row.GrossMarginPct || 0) / 100);
    }
  });

  const finalData  = Object.values(mergedData);
  const grandTotal = finalData.reduce((s, r) => s + r.TotalSales, 0);

  return finalData
    .map((row) => {
      const marginValue =
        row.TotalSales > 0 ? (row.GrossProfit / row.TotalSales) * 100 : 0;
      const split = categoryTargetsSplit[row.Field] || { total: 0, india: 0, overseas: 0 };
      return {
        Field:           row.Field,
        PercentageSales: grandTotal > 0
          ? Number(((row.TotalSales / grandTotal) * 100).toFixed(2)) : 0,
        Sales:           row.TotalSales,
        GrossMarginPct:  Number(marginValue.toFixed(2)),
        GrossProfit:     row.GrossProfit,
        IndiaSales:      row.IndiaSales,
        OverseasSales:   row.OverseasSales,
        Target:          split.total,
        TargetIndia:     split.india,
        TargetOverseas:  split.overseas,
      };
    })
    .sort((a, b) => b.Sales - a.Sales);
};

// ─── Process non-category types ──────────────────────────────────────────────
const processAllTypesData = (rawData, selectedType) => {
  if (!rawData || rawData.length === 0) return [];
  const grandTotal = rawData.reduce((s, r) => s + (r.Sales || 0), 0);
  return rawData
    .map((row) => {
      let grossProfit = row.GrossProfit || 0;
      if (grossProfit === 0 && row.GrossMarginPct && row.Sales) {
        grossProfit = (row.Sales || 0) * ((row.GrossMarginPct || 0) / 100);
      }
      const apiTarget    = typeof row.Target === 'number' ? row.Target : 0;
      const mappedTarget = selectedType === 'region' ? (regionTargets[row.Field] ?? 0) : 0;
      return {
        Field:          row.Field,
        PercentageSales: grandTotal > 0
          ? Number((((row.Sales || 0) / grandTotal) * 100).toFixed(2)) : 0,
        Sales:          row.Sales        || 0,
        GrossMarginPct: row.GrossMarginPct || 0,
        GrossProfit:    grossProfit,
        IndiaSales:     row.IndiaSales   || 0,
        OverseasSales:  row.OverseasSales || 0,
        Target:         apiTarget || mappedTarget,
      };
    })
    .sort((a, b) => b.Sales - a.Sales);
};

// ─── Main component ───────────────────────────────────────────────────────────
const PercentageAnalysis = () => {
  const [selectedType, setSelectedType] = useState('region');
  const [selectedYear, setSelectedYear] = useState('FY 2025-26');
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [selectedField,    setSelectedField]    = useState(null);

  const typeOptions = [
    { value: 'category',    label: 'Category'    },
    { value: 'state',       label: 'State'        },
    { value: 'region',      label: 'Region'       },
    { value: 'salesperson', label: 'Sales Person' },
  ];
  const yearOptions = ['FY 2025-26', 'FY 2024-25', 'Complete'];

  const shouldShowTargets = selectedYear === 'FY 2025-26';
  const isCategory        = selectedType === 'category';
  const showTarget        = shouldShowTargets && (isCategory || selectedType === 'region');

  useEffect(() => { fetchData(); }, [selectedType, selectedYear]);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await targetAnalyticsApi.getPercentageAnalysis(selectedType, selectedYear);
      const raw    = result?.data || [];
      const processed = isCategory
        ? mergePercentageCategories(raw)
        : processAllTypesData(raw, selectedType);
      setData(processed);
    } catch (err) {
      setError('Failed to load data');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const toCrores = (v) => ((v || 0) / 10000000).toFixed(2);

  const calculateTotalMargin = (rows) => {
    if (!rows || rows.length === 0) return 0;
    const totalSales = rows.reduce((s, r) => s + (r.Sales || 0), 0);
    const totalGP    = rows.reduce((s, r) => s + (r.GrossProfit || 0), 0);
    return totalSales > 0 ? Number(((totalGP / totalSales) * 100).toFixed(2)) : 0;
  };

  const handleCheckSales = (field) => {
    setSelectedField(field);
    setShowInvoiceModal(true);
  };

  // ProgressBar component
  const ProgressBar = ({ current, target, label }) => {
    const currentCr  = typeof current === 'number' ? current / 10000000 : 0;
    const targetCr   = typeof target  === 'number' ? target             : 0;
    const percentage = targetCr > 0 ? Math.min((currentCr / targetCr) * 100, 100) : 0;
    const getColor   = (p) => p >= 80 ? '#15803d' : p >= 60 ? '#22c55e' : p >= 40 ? '#f59e0b' : '#dc2626';

    return (
      <div className={styles.progressBarContainer}>
        <div className={styles.progressBarHeader}>
          {label && <span>{label}</span>}
          <span style={{ color: getColor(percentage) }}>{percentage.toFixed(1)}%</span>
        </div>
        <div className={styles.progressBarTrack}>
          <div className={styles.progressBarFill}
            style={{ width: `${percentage}%`, backgroundColor: getColor(percentage) }} />
          <div className={styles.progressBarText}>
            ₹{currentCr.toFixed(2)} / ₹{targetCr.toFixed(2)} Cr
          </div>
        </div>
      </div>
    );
  };

  const exportToExcel = () => {
    if (data.length === 0) { alert('No data to export'); return; }
    const totalMargin = calculateTotalMargin(data);
    const exportData  = data.map((row) => {
      const base = {
        Field: row.Field, 'Sales (Cr)': toCrores(row.Sales),
        '% Sales': row.PercentageSales, 'GM %': row.GrossMarginPct,
      };
      if (showTarget) {
        base['Target (Cr)']   = (row.Target || 0).toFixed(2);
        const cur             = parseFloat(toCrores(row.Sales));
        base['Achievement %'] = row.Target > 0 ? ((cur / row.Target) * 100).toFixed(1) : '0.0';
      }
      if (isCategory) {
        base['India Sales (Cr)']    = toCrores(row.IndiaSales);
        base['Overseas Sales (Cr)'] = toCrores(row.OverseasSales);
        if (shouldShowTargets) {
          base['India Target (Cr)']      = Number(row.TargetIndia    || 0).toFixed(2);
          base['Overseas Target (Cr)']   = Number(row.TargetOverseas || 0).toFixed(2);
          const iCur = parseFloat(toCrores(row.IndiaSales));
          base['India Achievement %']    = row.TargetIndia    > 0 ? ((iCur / row.TargetIndia)    * 100).toFixed(1) : '0.0';
          const oCur = parseFloat(toCrores(row.OverseasSales));
          base['Overseas Achievement %'] = row.TargetOverseas > 0 ? ((oCur / row.TargetOverseas) * 100).toFixed(1) : '0.0';
        }
      }
      return base;
    });
    const tt     = showTarget ? data.reduce((s, r) => s + (r.Target || 0), 0) : 0;
    const totals = {
      Field: 'TOTAL',
      'Sales (Cr)': toCrores(data.reduce((s, r) => s + (r.Sales || 0), 0)),
      '% Sales': 100.0, 'GM %': totalMargin,
    };
    if (showTarget) {
      totals['Target (Cr)']   = tt.toFixed(2);
      const cur               = parseFloat(toCrores(data.reduce((s, r) => s + (r.Sales || 0), 0)));
      totals['Achievement %'] = tt > 0 ? ((cur / tt) * 100).toFixed(1) : '0.0';
    }
    exportData.push(totals);
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Percentage Analysis');
    XLSX.writeFile(wb, `Percentage_Analysis_${selectedType}_${selectedYear}_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  const totalMargin         = calculateTotalMargin(data);
  const totalTargets        = showTarget ? data.reduce((s, r) => s + (r.Target        || 0), 0) : 0;
  const totalIndiaTarget    = showTarget && isCategory ? data.reduce((s, r) => s + (r.TargetIndia    || 0), 0) : 0;
  const totalOverseasTarget = showTarget && isCategory ? data.reduce((s, r) => s + (r.TargetOverseas || 0), 0) : 0;

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingSpinner} />
        <div className={styles.loadingText}>Loading data...</div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      {/* Filters */}
      <div className={styles.filtersSection}>
        <div className={styles.filterRow}>
          <div className={styles.filterGroup}>
            <label className={styles.filterLabel}>Financial Year:</label>
            <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} className={styles.select}>
              {yearOptions.map((y) => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
          <div className={styles.filterGroup}>
            <label className={styles.filterLabel}>Analysis By:</label>
            <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)} className={styles.select}>
              {typeOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
          <div className={styles.excelButtonWrapper}>
            <button onClick={exportToExcel} disabled={data.length === 0} className={styles.excelButton}>
              <span className={styles.excelIcon}>📊</span> Export Excel
            </button>
          </div>
        </div>
      </div>

      {error && <div className={styles.errorMessage}>{error}</div>}

      {data.length === 0 ? (
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>📊</div>
          <h3 className={styles.emptyTitle}>No Data Available</h3>
          <p className={styles.emptyText}>No data found for the selected filters</p>
        </div>
      ) : (
        <div className={styles.content}>
          <div className={styles.tableSection}>
            <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th className={styles.thSticky}>
                      {typeOptions.find((o) => o.value === selectedType)?.label}
                    </th>
                    <th className={styles.th}>Actions</th>
                    <th className={styles.th}>Sales (Cr)</th>
                    <th className={styles.th}>% Sales</th>
                    {showTarget && <th className={styles.th}>Target Achievement</th>}
                    <th className={styles.th}>GM %</th>
                    {isCategory && shouldShowTargets && (
                      <>
                        <th className={styles.th}>India Target Achievement</th>
                        <th className={styles.th}>Overseas Target Achievement</th>
                      </>
                    )}
                    {isCategory && !shouldShowTargets && (
                      <>
                        <th className={styles.th}>India Sales (Cr)</th>
                        <th className={styles.th}>Overseas Sales (Cr)</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {data.map((row, idx) => (
                    <tr key={idx} className={styles.tr}>
                      <td className={styles.tdSticky}>{row.Field}</td>
                      <td className={styles.td}>
                        <button onClick={() => handleCheckSales(row.Field)} className={styles.actionButton}>
                          📊 Check Sales
                        </button>
                      </td>
                      <td className={styles.tdRight}>₹{toCrores(row.Sales)} Cr</td>
                      <td className={styles.tdRightGreen}>{row.PercentageSales}%</td>
                      {showTarget && (
                        <td className={styles.tdRight}>
                          <ProgressBar current={row.Sales} target={row.Target} />
                        </td>
                      )}
                      <td className={`${styles.tdRight} ${row.GrossMarginPct >= 25 ? styles.gmGreen : styles.gmRed}`}>
                        {row.GrossMarginPct}%
                      </td>
                      {isCategory && shouldShowTargets && (
                        <>
                          <td className={styles.tdRight}>
                            <ProgressBar current={row.IndiaSales} target={row.TargetIndia} label="India" />
                          </td>
                          <td className={styles.tdRight}>
                            <ProgressBar current={row.OverseasSales} target={row.TargetOverseas} label="Overseas" />
                          </td>
                        </>
                      )}
                      {isCategory && !shouldShowTargets && (
                        <>
                          <td className={styles.tdRight}>₹{toCrores(row.IndiaSales)} Cr</td>
                          <td className={styles.tdRight}>₹{toCrores(row.OverseasSales)} Cr</td>
                        </>
                      )}
                    </tr>
                  ))}

                  {/* TOTAL row */}
                  <tr className={styles.totalRow}>
                    <td className={styles.tdStickyTotal}>TOTAL</td>
                    <td className={styles.td}></td>
                    <td className={styles.tdRightGreen}>
                      ₹{toCrores(data.reduce((s, r) => s + (r.Sales || 0), 0))} Cr
                    </td>
                    <td className={styles.tdRightGreen}>100.00%</td>
                    {showTarget && (
                      <td className={styles.tdRight}>
                        <ProgressBar current={data.reduce((s, r) => s + (r.Sales || 0), 0)} target={totalTargets} />
                      </td>
                    )}
                    <td className={`${styles.tdRight} ${totalMargin >= 25 ? styles.gmGreen : styles.gmRed}`}>
                      {totalMargin}%
                    </td>
                    {isCategory && shouldShowTargets && (
                      <>
                        <td className={styles.tdRight}>
                          <ProgressBar current={data.reduce((s, r) => s + (r.IndiaSales || 0), 0)} target={totalIndiaTarget} label="India Total" />
                        </td>
                        <td className={styles.tdRight}>
                          <ProgressBar current={data.reduce((s, r) => s + (r.OverseasSales || 0), 0)} target={totalOverseasTarget} label="Overseas Total" />
                        </td>
                      </>
                    )}
                    {isCategory && !shouldShowTargets && (
                      <>
                        <td className={styles.tdRightGreen}>₹{toCrores(data.reduce((s, r) => s + (r.IndiaSales || 0), 0))} Cr</td>
                        <td className={styles.tdRightGreen}>₹{toCrores(data.reduce((s, r) => s + (r.OverseasSales || 0), 0))} Cr</td>
                      </>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* Invoice Modal — rendered at root level so it's not clipped by table overflow */}
      {showInvoiceModal && (
        <InvoiceFilterModal
          show={showInvoiceModal}
          onClose={() => { setShowInvoiceModal(false); setSelectedField(null); }}
          preSelectedField={selectedField}
          selectedFilterType={selectedType}
          selectedYear={selectedYear}
        />
      )}
    </div>
  );
};

export default PercentageAnalysis;